/**
 * 试卷
 */

import {
    get,
    post,
    put,
    del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectExamById = (Id) => {
    return get('/api/app/Exam?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddExam = (data) => {
    return post('/api/app/Exam', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyExam = (data) => {
    return put('/api/app/Exam', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataExamList = (data) => {
    return post('/api/app/Exam/list', data, {});
}


/**
 * 链表分页获取
 * @param {*} data
 * @returns
 */
export const GetDataExamListByPageQuery = (data) => {
    return post('/api/app/Exam/getDataByPageQuery', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteExam = (id) => {
    return del('/api/app/Exam/' + id, {}, {});
}

/**
 * 试卷编辑
 * @param {*} data
 * @returns
 */
 export const ModifyExamData = (data) => {
    return post('/api/app/exam/modifyExam', data, {});
}

/**
 * 试卷新增
 * @param {*} data
 * @returns
 */
 export const AddExamData = (data) => {
    return post('/api/app/exam/exam', data, {});
}

/**
 * 试卷发布
 * @param {*} id  试卷id
 * @param {*} publishId  发布人,当前登录用户
 * @returns
 */
 export const PublishExam = (id,publishId) => {
    return post('/api/app/exam/'+id+'/publishExam/'+publishId);
}

/**
 * 4.通过试卷id获取试卷题目信息(WXAPI)
 * @param {*} Id
 * @returns
 */
export const GetExamInfoById = (Id) => {
    return get('/api/app/exam/'+Id+'/examById');
}